
import _Vue from "vue";
import UiDialogComponent from "./ui-dialog.vue";
import DialogModal, { DialogType, DialogButton } from "./model/dialogModal";
import  LocaleProvider  from "../localization/localization";

export default class Dialog {
    private mounted = false;
    // private Vue: typeof _Vue;
    private $root: UiDialogComponent;
    constructor() {
        // console.log('dialog init');
        // this.Vue = Vue;
    }

    alert(errorMsg: string): Promise<boolean> {//data:DialogModal) {
        return this.open(new DialogModal({
            Type: DialogType.Error,
            Text: errorMsg,
            Title: LocaleProvider.getTranslate("dialogAttention"),
            Buttons: [getOkButton()]
        }));
    }
    success(errorMsg: string): Promise<boolean> {//data:DialogModal) {
        return this.open(new DialogModal({
            Type: DialogType.Error,
            Text: errorMsg,
            Title: LocaleProvider.getTranslate("dialogAttention"),
            Buttons: [getOkButton()]
        }));
    }
    info(errorMsg: string): Promise<boolean> {//data:DialogModal) {
        return this.open(new DialogModal({
            Type: DialogType.Error,
            Text: errorMsg,
            Title: LocaleProvider.getTranslate("dialogAttention"),
            Buttons: [getOkButton()]
        }));
    }
    warning(errorMsg: string): Promise<boolean> {//data:DialogModal) {
        return this.open(new DialogModal({
            Type: DialogType.Error,
            Text: errorMsg,
            Title: LocaleProvider.getTranslate("dialogAttention"),
            Buttons: [getOkButton()]
        }));
    }
    custom(data: DialogModal): Promise<any> {
        return this.open(data);
    }
    private open(data: DialogModal): Promise<any> {
        return new Promise((resolve, reject) => {
            this.mountIfNotMounted();
            (this.$root as any).show(data);
            (this.$root as _Vue).$once('change', (res: any) => {
                console.log('res: ', res);
                resolve(res);
            })
        })
    }

    confirm(text: string, buttons?: DialogButton[]): Promise<boolean> {        
        return this.open(new DialogModal({
            Type: DialogType.Error,
            Text: text,
            Title: LocaleProvider.getTranslate("dialogAttention"),
            Buttons: buttons || [getYesButton(), getNoButton()]
        }));
    }
    private mountIfNotMounted() {
        if (this.mounted === true) {
            return;
        }
        console.log('method');
        // var s = typeof UiDialogComponent;
        let DialogConstructor = _Vue.extend(UiDialogComponent); //this.Vue.extend(UiDialogComponent)
        this.$root = new DialogConstructor();
        let node = document.createElement('div');
        document.querySelector('body').appendChild(node);
        this.$root.$mount(node);

        this.mounted = true;
    }
}

export const getYesButton = () => new DialogButton({Title:LocaleProvider.getTranslate("dialogBtnYes"), Value: true, Color: '#FFFFFF', BgColor: '#56A9EF'});
export const getNoButton = () => new DialogButton({Title:LocaleProvider.getTranslate("dialogBtnCancel"), Value: false, Color: '#162A47', BgColor: '#F0F0F0'});
export const getOkButton = () => new DialogButton({Title:'Ok', Value: true, Color: '#162A47', BgColor: '#F0F0F0'});



// let Plugin = function (Vue typeof _Vue, globalOptions = {}) {
// 	this.Vue = Vue
// 	this.mounted = false
// 	this.$root = {} // The root component
// 	this.registeredViews = {} // Custom components
// 	this.globalOptions = mergeObjs(DEFAULT_OPTIONS, globalOptions)
// }

// Plugin.prototype.mountIfNotMounted = function () {
// 	if (this.mounted === true) {
// 		return
// 	}

// 	this.$root = (() => {
// 		let DialogConstructor = this.Vue.extend(DialogComponent)
// 		let node = document.createElement('div')
// 		document.querySelector('body').appendChild(node)

// 		let Vm = new DialogConstructor()

// 		Vm.registeredViews = this.registeredComponents()

// 		return Vm.$mount(node)
// 	})()

// 	this.mounted = true
// }

// Plugin.prototype.registeredComponents = function () {
// 	return registeredViews
// }

// Plugin.prototype.registerComponent = function (name, definition) {
// 	if (this.mounted) {
// 		this.destroy()
// 	}

// 	// registeredViews[name] = this.Vue.extend(definition)
// 	registeredViews[name] = definition
// }

// Plugin.prototype.destroy = function () {
// 	if (this.mounted === true) {
// 		this.$root.forceCloseAll()

// 		let elem = this.$root.$el
// 		this.$root.$destroy()
// 		this.$root.$off()
// 		elem.remove()
// 		this.mounted = false
// 	}
// }

// Plugin.prototype.alert = function (message = null, options = {}) {
// 	message && (options.message = message)
// 	return this.open(DIALOG_TYPES.ALERT, options)
// }

// Plugin.prototype.prompt = function (message = null, options = {}) {
// 	message && (options.message = message)
// 	return this.open(DIALOG_TYPES.PROMPT, options)
// }

// Plugin.prototype.confirm = function (message = null, options = {}) {
// 	message && (options.message = message)
// 	return this.open(DIALOG_TYPES.CONFIRM, options)
// }

// Plugin.prototype.open = function (type, localOptions = {}) {
// 	this.mountIfNotMounted()
// 	return new Promise((resolve, reject) => {
// 		localOptions.id = 'dialog.' + Date.now()
// 		localOptions.window = type
// 		localOptions.promiseResolver = resolve
// 		localOptions.promiseRejecter = reject

// 		this.$root.commit(mergeObjs(this.globalOptions, localOptions))
// 	})
// }

// Plugin.install = function (Vue, options) {
// 	let DirectivesObj = new Directives(Vue)

// 	// Vue.directive('confirm', DirectivesObj.confirmDefinition)

// 	Vue.dialog = new Plugin(Vue, options)

// 	Object.defineProperties(Vue.prototype, {
// 		$dialog: {
// 			get () {
// 				return Vue.dialog
// 			}
// 		}
// 	})
// }


// WEBPACK FOOTER //
// ./scripts/plugins/dialog/dialog.ts